import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../styles';
import PlusCertificateIcon from 'assets/svgComponents/PlusCertificateIcon';

interface AddCertificateCardProps {
  onAddCertificate: () => void;
}

const AddCertificateCard: React.FC<AddCertificateCardProps> = ({ onAddCertificate }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <button className={`${classes.addCertificateCard} ${classes.addCertificateCardSmall}`} data-testid="add-certificate-button" onClick={onAddCertificate}>
      <div className={classes.addCertificateIcon}>
        <PlusCertificateIcon />
      </div>
      <span className={classes.addCertificateText}>{t('certifications.addNewCertificate')}</span>
    </button>
  );
};

export default AddCertificateCard;
